/** Client-side handlers for Flowy media feedback quick replies. */

export const MEDIA_LIKE_QUICK_REPLY_ID = 'media_like_it';
export const MEDIA_ADD_TO_BOARD_QUICK_REPLY_ID = 'media_add_to_board';

export const isMediaLikeQuickReply = (reply: { id?: string; value?: string }): boolean => {
	if (reply.id === MEDIA_LIKE_QUICK_REPLY_ID) return true;
	return /^I like this (image|video)$/i.test((reply.value || '').trim());
};

export const isMediaAddToBoardQuickReply = (reply: { id?: string; value?: string }): boolean => {
	if (reply.id === MEDIA_ADD_TO_BOARD_QUICK_REPLY_ID) return true;
	return /^Add this (image|video) to the board$/i.test((reply.value || '').trim());
};

export type GenerateResultItemLike = {
	classList: { contains: (token: string) => boolean };
	querySelector: (selectors: string) => GenerateResultItemLike | null;
	click: () => void;
};

/**
 * Prefer Flowy's highlighted pick; otherwise the first generate list item
 * (typically the newest / top media result).
 */
export const pickGenerateResultItem = <T extends GenerateResultItemLike>(
	items: ReadonlyArray<T>
): T | null => {
	if (!items.length) return null;
	const recommended = items.find((item) => item.classList.contains('flowy-recommended-result'));
	if (recommended) return recommended;
	const media = items.find(
		(item) =>
			item.classList.contains('image-result') ||
			Boolean(item.querySelector('img, video, source'))
	);
	return media || items[0] || null;
};

export const likeGenerateResultItem = (item: GenerateResultItemLike): boolean => {
	const heart = item.querySelector('.heart');
	if (!heart) return false;
	if (heart.classList.contains('liked')) return true;
	// Click the heart image so list-item handlers treat this as a heart click
	// (they key off IMG inside .heart) and do not also add to the board.
	const heartImage = heart.querySelector('img');
	(heartImage || heart).click();
	return true;
};

export const addGenerateResultItemToBoard = (item: GenerateResultItemLike): boolean => {
	// Inspire media results register a list-item click handler that places the
	// node. Idea-box-only cards omit that handler — fall back to hearting.
	if (item.classList.contains('generate-list-item')) {
		item.click();
		return true;
	}
	return likeGenerateResultItem(item);
};
